import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPointDown } from '@fortawesome/free-regular-svg-icons';
import React from 'react';

const mustacheSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" enableBackground="new 0 0 50 50" xmlSpace="preserve" className="svg mustache replaced-svg">
        <path d="M41.816,23.758c-3.854,0.215-4.931-5.379-10.488-5.469c-3.86-0.063-5.642,2.555-6.328,4.642  c-0.687-2.087-2.468-4.705-6.33-4.642c-5.558,0.09-6.635,5.684-10.488,5.469c-2.312-0.138-4.689,0.303-7.978-6.007  c0,0,0.269,16.673,12.19,16.493c3.686,0.081,10.947-1.213,12.604-6.929c1.657,5.716,8.918,7.01,12.603,6.929  c11.922,0.18,12.191-16.493,12.191-16.493C46.506,24.061,44.128,23.62,41.816,23.758z"></path>
    </svg>
);

interface LogoProps {
    onMustacheClick: () => void;
}

const Logo: React.FC<LogoProps> = ({ onMustacheClick }) => {

    const handleClick = () => {
        onMustacheClick();
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === 'Enter') {
            onMustacheClick();
        }
    };

    return (
        <section className="logo">
            <div>
                <div className='point'>
                    <div>
                        <span className="cover"></span>click the mustache
                        <FontAwesomeIcon icon={faHandPointDown} />
                    </div>
                </div>
                <h1>
                    <span>Nick</span>
                    <div className="tool-mustache-wrap">
                        <div
                            className={`mustache-wrap`}
                            tabIndex={0}
                            onClick={handleClick}
                            onKeyDown={handleKeyDown}>
                            {mustacheSVG}
                        </div>
                        <div className="tool" aria-hidden="true">
                            <span>pronounced dime-ler</span>
                        </div>
                    </div>
                    Deimler
                </h1>
            </div>
        </section>
    );
}

export default Logo;